// src/translations.js
export const translations = {
    ru: {
      title: 'Sonifly',
      subtitle: 'Транслируйте звук с компьютера на любое устройство Android — мгновенно и без проводов.',
      downloadBtn: 'Скачать сейчас',
      why: 'Почему Sonifly?',
      feature1: 'Без задержек',
      feature1Desc: 'Низкая задержка передачи звука — идеально подходит для просмотра видео и игр.',
      feature2: 'Простое подключение',
      feature2Desc: 'Подключайтесь по Wi-Fi за пару кликов. Никаких сложных настроек.',
      feature3: 'Кроссплатформенность',
      feature3Desc: 'Работает с Windows и Android. Расширяйте зону воспроизведения звука.',
      download: 'Скачать Sonifly',
      winBtn: 'Скачать для Windows',
      androidBtn: 'Скачать для Android',
      compatibility: 'Совместимо с Android 7.0+ и Windows 10/11',
      instruction: 'Инструкция',
step1: 'Скачайте и установите SoniFly на ПК',
step1Desc: 'Загрузите сервер для Windows по ссылке: <a href="https://sonifly.top/download/sonifly-windows-setup.exe" style="color: #4A90E2; font-weight: bold; text-decoration: none;">⬇️ Скачать</a>. Установите и запустите — он будет работать в фоне.',

step2: 'Установите приложение на Android',
step2Desc: 'Установите это приложение на телефон. При первом запуске разрешите доступ к уведомлениям — так вы будете видеть статус подключения.',

step3: 'Подключите устройства к одной сети',
step3Desc: 'ПК и телефон должны быть в одной Wi-Fi сети (подсеть /24, например 192.168.1.x). Отключите фаервол на ПК, если подключение не работает.',

step4: 'Найдите сервер и подключитесь',
step4Desc: 'Нажмите “Найти сервер” — приложение попытается найти ПК автоматически. Если не найдёт — введите локальный IP ПК вручную и нажмите “Подключиться”.',

step5: 'Запустите звук на ПК — и слушайте на телефоне!',
step5Desc: 'Включите музыку, видео или игру на ПК — звук будет транслироваться на ваш Android: в наушники, колонки или ТВ через HDMI/Chromecast.',
step6: 'Сохраните профиль для быстрого подключения',
step6Desc: 'Включите “Сохранить Wi-Fi” в настройках. При переключении на сохранённую сеть приложение автоматически подставит нужный IP-адрес сервера. Для этого может потребоваться доступ к местоположению — используется только локально, данные не передаются.',
      footer: '© 2025 Sonifly. Все права защищены.',
      contact: 'Связь: support@sonifly.top',
      langSwitch: 'English',
      home: 'Главная',
      lightTheme: '☀️ Светлая тема',
      darkTheme: '🌙 Тёмная тема',
      // В RU:
      faqTitle: 'Частые вопросы',
      faq1: 'Почему наше приложение?',
      faq1Answer: 'Sonifly создан для тех, кто ценит качество звука и простоту. Мы не используем облако, не собираем ваши данные — всё работает локально, быстро и безопасно.',
      faq2: 'Как работает приложение?',
      faq2Answer: 'Sonifly создаёт прямое соединение между вашим ПК и Android-устройством по Wi-Fi. Звук передаётся в реальном времени без загрузки на серверы. Просто установите приложение на оба устройства — и наслаждайтесь.',
      faq3: 'Как достигаются низкие задержки?',
      faq3Answer: 'Мы используем оптимизированный аудиокодек и кольцевое буферирование, что минимизирует задержки и обеспечивает лучшее качество звука. Кроме того, приложение работает на уровне драйверов Windows, что позволяет захватывать звук с минимальной латентностью.',
      faq4: 'Я хочу скачать для другой ОС / архитектуры',
      faq4Answer: 'Сейчас доступны версии для Windows (x64) и Android (ARM64). Если вам нужна сборка для Linux, macOS или другой архитектуры — напишите нам на support@sonifly.app. Мы рассматриваем все запросы и добавляем поддержку по мере спроса.',
      // В RU:
      contactFormTitle: 'Свяжитесь с нами',
      contactFormName: 'Ваше имя',
      contactFormNamePlaceholder: 'Введите ваше имя',
      contactFormEmail: 'Email',
      contactFormEmailPlaceholder: 'example@mail.com',
      contactFormMessage: 'Сообщение',
      contactFormMessagePlaceholder: 'Расскажите нам, как мы можем вам помочь...',
      contactFormSubmit: 'Отправить сообщение',
      contactFormSending: 'Отправка...',
      contactFormSuccess: 'Спасибо! Мы свяжемся с вами в ближайшее время.',
      contactFormError: 'Произошла ошибка. Попробуйте позже.',
      // Privacy Policy
      privacyPolicyTitle: 'Политика конфиденциальности',
      privacyPolicyContent: `✅ Политика конфиденциальности для SoniFly (аудио-стример с ПК на телефон)
Последнее обновление: 16 сентября 2025 г.

SoniFly («мы», «наше», «приложение») — это локальный инструмент для потоковой передачи звука, который передает звук с вашего компьютера с Windows на ваше устройство Android через локальную сеть Wi-Fi. Мы не собираем, не храним и не передаем никаких персональных данных.

🔒 Используемые разрешения и причины:
Доступ к уведомлениям — только для отображения статуса подключения и информации о потоковой передаче в шторке уведомлений Android. Данные не считываются и не отправляются во внешние источники.
Местоположение (Грубое/Точное) — необязательно. Запрашивается только в том случае, если пользователь включает «Автоматическое переключение на сохраненные профили Wi-Fi/IP». Используется для обнаружения, когда вы входите в известную сеть (например, домашнюю/рабочую), чтобы автоматически подключиться к правильному IP-адресу сервера. Местоположение никогда не сохраняется и не передается — проверяется только локально на устройстве.
Доступ к сети — требуется для обнаружения и подключения к вашему локальному серверу ПК. Весь трафик остается в пределах вашей локальной сети.
📭 Сбор данных:
Никакой. Мы не используем аналитику, рекламу, трекеры или облачные сервисы. Данные не покидают ваше устройство или локальную сеть.

📞 Связаться с нами:
Если у вас есть вопросы о конфиденциальности или разрешениях, свяжитесь с нами по адресу:
📧 support@sonifly.top
Мы отвечаем в течение 24–48 часов.`,
    },
    en: {
      title: 'Sonifly',
      subtitle: 'Stream audio from your PC to any Android device — instantly and wirelessly.',
      downloadBtn: 'Download now',
      why: 'Why Sonifly?',
      feature1: 'Low latency',
      feature1Desc: 'Minimal audio delay — perfect for videos and gaming.',
      feature2: 'Easy setup',
      feature2Desc: 'Connect over Wi-Fi in seconds. No complicated setup.',
      feature3: 'Cross-platform',
      feature3Desc: 'Works with Windows and Android. Extend your audio experience.',
      download: 'Download Sonifly',
      winBtn: 'Download for Windows',
      androidBtn: 'Download for Android',
      compatibility: 'Compatible with Android 7.0+ and Windows 10/11',
      instruction: 'Instructions',
step1: 'Download and install SoniFly on your PC',
step1Desc: 'Get the Windows server from: <a href="https://sonifly.top/download/sonifly-windows-setup.exe" style="color: #4A90E2; font-weight: bold; text-decoration: none;">⬇️ Download</a>. Install and run it — it will work in the background (check system tray).',

step2: 'Install the app on your Android device',
step2Desc: 'Install this app on your phone. On first launch, allow notification access — you’ll see connection status and streaming info there.',

step3: 'Connect both devices to the same Wi-Fi network',
step3Desc: 'PC and phone must be on the same local network (/24 subnet, e.g., 192.168.1.x). Disable Windows Firewall if connection fails.',

step4: 'Find your server and connect',
step4Desc: 'Tap “Find Server” — the app will search automatically. If not found, manually enter your PC’s local IP address and tap “Connect”.',

step5: 'Play audio on PC — listen on your phone!',
step5Desc: 'Start YouTube, Spotify, or a game on PC — audio will stream to your Android device: headphones, speakers, or TV via HDMI/Chromecast.',

step6: 'Save Wi-Fi profiles for auto-connect (optional)',
step6Desc: 'Enable “Save Wi-Fi” in settings. When switching to a saved network, the app will auto-fill the correct server IP address. Location access may be required — used locally only, no data is transmitted.',
      footer: '© 2025 Sonifly. All rights reserved.',
      contact: 'Contact: support@sonifly.top',
      langSwitch: 'Русский',
      home: 'Home',
      lightTheme: '☀️ Light theme',
      darkTheme: '🌙 Dark theme',
      // В EN:
      faqTitle: 'Frequently Asked Questions',
      faq1: 'Why our app?',
      faq1Answer: 'Sonifly is built for those who value sound quality and simplicity. We don’t use the cloud or collect your data — everything works locally, fast and securely.',
      faq2: 'How does it work?',
      faq2Answer: 'Sonifly creates a direct connection between your PC and Android device over Wi-Fi. Audio is streamed in real time without uploading to servers. Just install the app on both devices — and enjoy.',
      faq3: 'How do you achieve low latency?',
      faq3Answer: 'We use an optimized audio codec and ring buffering to minimize latency and deliver superior sound quality. Additionally, the app operates at the Windows driver level, enabling audio capture with minimal delay.',
      faq4: 'I want to download for another OS / architecture',
      faq4Answer: 'Currently available for Windows (x64) and Android (ARM64). If you need a build for Linux, macOS, or another architecture — email us at support@sonifly.app. We consider all requests and add support based on demand.',
      // В EN:
      contactFormTitle: 'Contact Us',
      contactFormName: 'Your Name',
      contactFormNamePlaceholder: 'Enter your name',
      contactFormEmail: 'Email',
      contactFormEmailPlaceholder: 'example@mail.com',
      contactFormMessage: 'Message',
      contactFormMessagePlaceholder: 'Tell us how we can help you...',
      contactFormSubmit: 'Send Message',
      contactFormSending: 'Sending...',
      contactFormSuccess: 'Thank you! We will contact you soon.',
      contactFormError: 'An error occurred. Please try again later.',
      // Privacy Policy
      privacyPolicyTitle: 'Privacy Policy',
      privacyPolicyContent: `✅ Privacy Policy for SoniFly (PC-to-Phone Audio Streamer)
Last Updated: Sep 16, 2025

SoniFly (“we”, “our”, “app”) is a local audio streaming tool that transmits sound from your Windows PC to your Android device over your local Wi-Fi network. We do not collect, store, or transmit any personal data.

🔒 Permissions Used & Why:
Notification Access — Only to show connection status and streaming info in Android notification shade. No data is read or sent externally.
Location (Coarse/Fine) — Optional. Only requested if user enables “Auto-switch to saved Wi-Fi/IP profiles”. Used to detect when you enter a known network (e.g., home/work) to auto-connect to the correct server IP. Location is never stored or transmitted — checked only locally on device.
Network Access — Required to discover and connect to your local PC server. All traffic stays within your local network.
📭 Data Collection:
None. We do not use analytics, ads, trackers, or cloud services. No data leaves your device or local network.

📞 Contact Us:
If you have questions about privacy or permissions, contact us at:
📧 support@sonifly.top
We respond within 24–48 hours.`,
    },
  };